import * as tabler from '@tabler/core';
import "@tabler/core/dist/css/tabler.css";
import "@tabler/core/dist/css/tabler-vendors.css";

window.tabler = tabler;
